// 客服帮用户创建回收订单PC页
export default {
  path: '/help-create-order',
  name: 'help-create-order',
  component: () =>
    import(/* webpackChunkName: "help-create-order" */ 'app/customer-service/index.vue')
}
